/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
    useLazyQuery, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';
import { GET_USERS_FOR_PROFILE } from 'Apollo/Queries';
import { DOWNLOAD_FILE, GET_DIRECTORY_DETAILS } from 'Apollo/Queries/DataRecon';
import {
    Breadcrumb, BreadcrumbItem, Panel, Tooltip,
} from 'appkit-react';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { useEffect, useRef, useState } from 'react';
import { NavDropdown } from 'react-bootstrap';

import { renamedFileMessagesVar } from 'Apollo/config';
import { DELETE_DIRECTORY_OR_FILE } from 'Apollo/Mutations/DataRecon';
import { getAuthorizationHeaderValue, getAccessToken } from 'views/Auth/AuthHelper';
import CustomAlert from 'views/Shared/components/CustomAlert';
import DefaultAlert from 'views/Shared/components/DefaultAlert';
import { ContentTypeEnum } from '../../../../constants';
import FileExplorer from '../components/FileExplorer';
import CreateNewFolderContainer from './CreateNewFolderContainer';
import DeleteFileContainer from './DeleteFileContainer';
import MoveFilesContainer from './MoveFilesContainer';
import RenameFileContainer from './RenameFileContainer';
import ShareFilesContainer from './ShareFilesContainer';

const baseLink = process.env.REACT_APP_BASE_LINK;

const showDownload = true;

const FileExplorerContainer = ({
    tenantId, AddFilesFlag, setfilesToAdd, AddFilesToCrossReportFlag,
    setFileName,
}) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [currentDir, setCurrentDir] = useState(null);
    const [isCreateFolderModalVisible, setIsCreateFolderModalVisible] = useState(false);
    const [isFileRenameModalVisible, setIsFileRenameModalVisible] = useState(false);
    const [isFileDeleteModalVisible, setIsFileDeleteModalVisible] = useState(false);
    const [isShareFilesModalVisible, setIsShareFilesModalVisible] = useState(false);
    const [isMoveFilesModalVisible, setIsMoveFilesModalVisible] = useState(false);
    const [disableRename, setDisableRename] = useState(false);
    const [isSharedDirectory, setIsSharedDirectory] = useState(false);
    const [isFileUploading, setIsFileUploading] = useState(false);
    const [dataforDelete, setDataforDelete] = useState({});
    const [showDeleteToast, setShowDeleteToast] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const renamedFileMessages = useReactiveVar(renamedFileMessagesVar);

    // state for file explorer
    const [selection, setSelection] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const fileInputRef = useRef();

    const sharedWithMeDirText = 'Shared with me';

    /* Apollo query to fetch row details  */
    const users = useQuery(GET_USERS_FOR_PROFILE, {
        variables: {
            input: {
                tenantId: parseInt(tenantId, 10),
                getAll: true,
            },
        },
        fetchPolicy: 'no-cache',
    });

    const [download, {
        data: fileData, loading: downloadLoading,
    }] = useLazyQuery(DOWNLOAD_FILE);

    const [deleteFolderOrFile] = useMutation(DELETE_DIRECTORY_OR_FILE);

    const [getDirDetails, {
        data: dirData, loading: dirDetailsLoading,
    }] = useLazyQuery(GET_DIRECTORY_DETAILS, {
        variables: {
            // userId: parseInt(loggedUserId, 10),
            dirId: currentDir,
        },
        fetchPolicy: 'no-cache',
    });

    useEffect(() => {
        if (fileData && fileData.DQdownloadFile) {
            const csv = fileData.DQdownloadFile.fileData.replace('{"data": "', '').replace('\\n"}', '').split('\\n');
            const result = csv.map(row => row.split(','));
            const result2 = result.join('\n');
            const name = fileData.DQdownloadFile.fileName;
            const blob = new Blob([result2], { type: 'text/csv' });
            saveAs(blob, `${name}.csv`);
            setToastMessage('Download is completed.');
        }
    }, [fileData]);

    useEffect(() => {
        getDirDetails();
    }, [tenantId]);

    const breadcrumbContent = dirData && dirData.DQgetDirDetails && dirData.DQgetDirDetails.dirTree;

    const parentDir = dirData && dirData.DQgetDirDetails && dirData.DQgetDirDetails.dirId;

    useEffect(() => {
        // Reset file/folder selection breadcrumbContent changes
        setSelection([]);
        const result = breadcrumbContent && breadcrumbContent.find(dir => dir.dirName === sharedWithMeDirText);
        if (result) {
            setIsSharedDirectory(true);
        } else {
            setIsSharedDirectory(false);
        }
    }, [breadcrumbContent]);

    // Making file and folder ids unique
    const filteredFileData = dirData && dirData.DQgetDirDetails
        && dirData.DQgetDirDetails.dirContents
            .map(item => ({ ...item, originalId: item.id, id: `${item.id}_${item.type}` }));

    const [updatedDirContents, setUpdatedDirContents] = useState(filteredFileData);

    useEffect(() => {
        setUpdatedDirContents(filteredFileData);
    }, [dirData]);

    useEffect(() => {
        const selectedRow = updatedDirContents && updatedDirContents.find(element => element.name === sharedWithMeDirText);

        if (selectedFiles && selectedFiles.includes(selectedRow && selectedRow.id)) {
            setDisableRename(true);
        } else {
            setDisableRename(false);
        }
    }, [selectedFiles]);

    useEffect(() => {
        if (AddFilesFlag) {
            const filesToAdd = [];
            selection && selection.forEach(file => {
                const result = updatedDirContents && updatedDirContents.find(element => element.id === file);
                if (result) {
                    filesToAdd.push(result);
                }
            });
            const fileOrFolderInput = filesToAdd && filesToAdd.map(item => (item.originalId));
            setfilesToAdd(fileOrFolderInput);
        }
    }, [AddFilesFlag, selection]);

    useEffect(() => {
        if (AddFilesToCrossReportFlag) {
            const filesToAdd = [];
            selection && selection.forEach(file => {
                const result = updatedDirContents && updatedDirContents.find(element => element.id === file);
                if (result) {
                    filesToAdd.push(result);
                }
            });
            const containFolder = filesToAdd && filesToAdd.find(element => element.type === 'directory');
            if (!containFolder) {
                const fileInput = filesToAdd && filesToAdd.map(item => (item.originalId));
                const fileName = filesToAdd && filesToAdd.map(item => (item.name));
                setfilesToAdd(fileInput);
                setFileName(fileName);
            } else {
                setfilesToAdd([]);
                setFileName(null);
            }
        }
    }, [AddFilesToCrossReportFlag, selection]);

    const fileExporerBreadcrumb = (
        <Breadcrumb className="a-apply-theme-background-transparent">
            {breadcrumbContent && breadcrumbContent.map(item => (
                <BreadcrumbItem
                    key={item.dirId}
                    onClick={() => {
                        setCurrentDir(item.dirId);
                        setSelectedFiles([]);
                    }}
                >
                    <span
                        className={
                            `appkiticon ${item.dirName === sharedWithMeDirText ? 'icon-stewardship-fill' : 'icon-folder-opened-fill'}`
                        }
                        style={{ color: '#ffb600' }}
                    />
                    <span className="a-breadcrumb-item-text" style={{ fontSize: '0.9rem', color: '#000000' }}>{item.dirName}</span>
                </BreadcrumbItem>
            ))}
        </Breadcrumb>
    );

    const fetchFolderData = data => {
        setSelectedFiles([]);
        if (data.type === 'directory') {
            setCurrentDir(data.originalId);
        }
    };

    const fileSelectionChangeHandler = data => {
        setSelectedFiles(data);
    };

    const onUploadFiles = async event => {
        const filesResult = event.target.files;
        const token = getAuthorizationHeaderValue();
        const fd = new FormData();
        fd.append('dirId', parentDir);
        fd.append('tenantId', tenantId);
        const existingFiles = updatedDirContents && updatedDirContents.filter(file => file.type === 'file');
        let messages = '';
        for (let i = 0; i < filesResult.length; i++) {
            const result = existingFiles && existingFiles.find(oldFile => oldFile.name === filesResult[i].name);
            // If the file is already exists modify file name
            if (result) {
                const oldFileName = result.name.split('.')[0];

                // If the file name is duplicating first time.
                if (!oldFileName.match(/\((\d+)\)/g)) {
                    const nameToCompare = result.name.split('.')[0];
                    let count = 0;
                    existingFiles && existingFiles.forEach(file => {
                        // check only those files having (
                        if (file.name.includes(nameToCompare) && file.name.match(/\((\d+)\)/g)) {
                            const currentCount = parseInt((file && file.name.split('.')[0]).split('(')[1].split(')')[0], 10);
                            if (count < currentCount) {
                                count = currentCount;
                            }
                        }
                    });
                    count += 1;
                    const newFileName = `${nameToCompare} (${count}).csv`;
                    fd.append('files', filesResult[i], newFileName);
                    messages = messages.concat(`@ Uploaded file renamed to "${newFileName}" as "${result.name}" already exists`);
                } else {
                    // If the file name is duplicating second time onwards.

                    // Getting original name.
                    const nameToCompare = result.name.split('(')[0];
                    let count = 0;
                    existingFiles && existingFiles.forEach(file => {
                        if (file.name.includes(nameToCompare)) {
                            const currentCount = parseInt((file.name.split('.')[0]).split('(')[1].split(')')[0], 10);
                            if (count < currentCount) {
                                count = currentCount;
                            }
                        }
                    });
                    count += 1;
                    const newFileName = `${nameToCompare}(${count}).csv`;
                    fd.append('files', filesResult[i], newFileName);
                    messages = messages.concat(`@ Uploaded file renamed to "${newFileName}" as "${result.name}" already exists`);
                }
            } else {
                // If the file is new add as it is.
                fd.append('files', filesResult[i]);
            }
        }

        const url = `${baseLink}api/reconciliation/uploadReconFiles`;
        try {
            setIsFileUploading(true);
            await axios.post(url, fd, {
                headers: {
                    'Content-Type': ContentTypeEnum.MULTIPART,
                    authorization: token ? `Bearer ${token}` : '',
                    token: getAccessToken(),
                    'x-isRestAPI': true,
                },
            });
            setToastMessage('Your File upload is complete.');
            renamedFileMessagesVar(messages);
            setIsFileUploading(false);
            fileInputRef.current.value = null;
            getDirDetails();
        } catch (e) {
            //
        }
    };

    const onRefreshFileExplorer = () => {
        getDirDetails();
    };

    // Menu actions
    const renameFileOrFolder = () => {
        setIsFileRenameModalVisible(true);
    };

    const moveFileOrFolder = () => {
        setIsMoveFilesModalVisible(true);
    };

    // Just opens confirmation modal
    const deleteFileOrFolder = () => {
        setIsFileDeleteModalVisible(true);
    };

    // delete files/folders on confirmation
    const onConfirmDelete = data => {
        setShowDeleteToast(true);
        setDataforDelete(data);
        setIsFileDeleteModalVisible(false);
        const result = filteredFileData && filteredFileData.filter(fileEle => !(data && data.deleteList).find(element => fileEle.originalId === element.id));
        setUpdatedDirContents(result);
    };

    useEffect(() => {
        const deleteFiles = async () => {
            await deleteFolderOrFile({
                variables: {
                    ...dataforDelete,
                },
            });
            setConfirmDelete(false);
            setSelectedFiles([]);
            getDirDetails();
        };
        if (confirmDelete) {
            deleteFiles();
        }
    }, [confirmDelete, dataforDelete]);

    const undoAction = () => {
        setIsFileDeleteModalVisible(false);
        setShowDeleteToast(false);
        setUpdatedDirContents(filteredFileData);
    };

    const downloadFiles = async () => {
        const result = selectedFiles[0].split('_');
        await download({
            variables: {
                fileId: parseInt(result[0], 10),
            },
            fetchPolicy: 'no-cache',
        });
    };

    const shareFiles = () => {
        setIsShareFilesModalVisible(true);
    };

    return (
        <Panel
            title="FILE EXPLORER"
            className="a-increase-child-color-level-by-1"
            renderRight={() => (
                <>
                    {isFileUploading
                        && (
                            <>
                                <span className="a-loading a-primary a-m-10 a-loading-8" style={{ width: '1.3rem', height: '1.3rem' }} />
                                <span style={{ marginRight: '1rem' }}>Uploading . . .</span>
                            </>
                        )}
                    {downloadLoading
                        && (
                            <>
                                <span className="a-loading a-primary a-m-10 a-loading-8" style={{ width: '1.3rem', height: '1.3rem' }} />
                                <span style={{ marginRight: '1rem' }}>Downloading . . .</span>
                            </>
                        )}
                    {!isSharedDirectory && (
                        <Tooltip content="New folder" placement="top" tooltipTheme="light">
                            <span
                                className="appkiticon icon-folderadd-outline new-folder-icon"
                                onClick={() => setIsCreateFolderModalVisible(true)}
                                role="button"
                                style={{ fontSize: '1.6rem', cursor: 'pointer' }}
                                onKeyDown={() => {
                                    // no action needed
                                }}
                                tabIndex={0}
                            />
                        </Tooltip>
                    )}
                    {!isSharedDirectory && (
                        <Tooltip content="Upload" placement="top" tooltipTheme="light">
                            <span
                                className="appkiticon icon-upload-light-outline upload-icon"
                                onClick={() => {
                                    fileInputRef.current.click();
                                }}
                                role="button"
                                style={{ marginLeft: '1rem', fontSize: '1.2rem', cursor: 'pointer' }}
                                onKeyDown={() => {
                                    // no action needed
                                }}
                                tabIndex={0}
                            />
                        </Tooltip>
                    )}
                    <input
                        type="file"
                        accept=".csv"
                        multiple
                        ref={fileInputRef}
                        onInput={e => onUploadFiles(e)}
                        hidden
                    />
                    <Tooltip content="Refresh" placement="top" tooltipTheme="light">
                        <span
                            className="appkiticon icon-refresh-outline refresh-icon"
                            onClick={() => onRefreshFileExplorer()}
                            role="button"
                            tabIndex={0}
                            style={{ fontSize: '1.3rem', cursor: 'pointer' }}
                            onKeyDown={() => {
                                // no action needed
                            }}
                        />
                    </Tooltip>

                    <NavDropdown
                        title={(
                            <Tooltip content="Actions" placement="top" tooltipTheme="light" style={{ marginTop: '-1.5rem' }}>
                                <span
                                    className="appkiticon icon-vertical-more-outline actions-icon"
                                    style={{ fontSize: '1.1rem', cursor: 'pointer' }}
                                />
                            </Tooltip>
                        )}
                        id="basic-nav-dropdown"
                        className=""
                    >
                        <NavDropdown.Item
                            onClick={downloadFiles}
                            disabled={(selectedFiles.length !== 1 || disableRename || selectedFiles[0].split('_')[1] === 'directory')}
                        >
                            Download
                        </NavDropdown.Item>
                        <NavDropdown.Item
                            onClick={renameFileOrFolder}
                            disabled={selectedFiles.length !== 1 || isSharedDirectory || disableRename}
                        >
                            Rename
                        </NavDropdown.Item>
                        <NavDropdown.Item
                            onClick={moveFileOrFolder}
                            disabled={selectedFiles.length === 0 || isSharedDirectory || disableRename}
                        >
                            Move
                        </NavDropdown.Item>
                        <NavDropdown.Item
                            onClick={shareFiles}
                            disabled={selectedFiles.length === 0 || isSharedDirectory || disableRename}
                        >
                            Share
                        </NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item
                            onClick={deleteFileOrFolder}
                            disabled={
                                selectedFiles.length === 0
                                || isSharedDirectory
                                || disableRename
                            }
                        >
                            Delete
                        </NavDropdown.Item>
                    </NavDropdown>
                </>
            )}
            style={{ paddingBottom: '2rem' }}
        >
            {showDeleteToast
                && (
                    <CustomAlert
                        message="File deletion is complete."
                        durationInMS="5000"
                        confirmation={setConfirmDelete}
                        setShowDeleteToast={setShowDeleteToast}
                        undoAction={undoAction}
                        showDeleteToast={showDeleteToast}
                    />
                )}

            {toastMessage
                && (
                    <DefaultAlert
                        status="success"
                        toastMessage={toastMessage}
                        setToastMessage={setToastMessage}
                    />
                )}

            {renamedFileMessages
                && (
                    <DefaultAlert
                        status="success"
                        toastMessage={renamedFileMessages}
                        setToastMessage={() => renamedFileMessagesVar('')}
                        displayOneLine={false}
                        customStyle={{
                            position: 'fixed',
                            top: '7.3rem',
                            left: '6rem',
                            boxShadow: '1px 1px 10px 1px grey',
                            zIndex: 1,
                        }}
                    />
                )}

            {isFileDeleteModalVisible
                && (
                    <DeleteFileContainer
                        visible={isFileDeleteModalVisible}
                        setVisible={setIsFileDeleteModalVisible}
                        getDirDetails={getDirDetails}
                        fileExplorerDataSource={updatedDirContents}
                        selectedFiles={selectedFiles}
                        parentDir={parentDir}
                        setSelectedFiles={setSelectedFiles}
                        onConfirmDelete={onConfirmDelete}
                    />
                )}

            {isMoveFilesModalVisible
                && (
                    <MoveFilesContainer
                        visible={isMoveFilesModalVisible}
                        setVisible={setIsMoveFilesModalVisible}
                        refreshFileExplorer={getDirDetails}
                        oldFileExplorerDataSource={updatedDirContents}
                        filesToMove={selectedFiles}
                        previousDir={parentDir}
                        users={users && users.data && users.data.getUsers}
                        setToastMessage={setToastMessage}
                    />
                )}

            {isShareFilesModalVisible
                && (
                    <ShareFilesContainer
                        visible={isShareFilesModalVisible}
                        setVisible={setIsShareFilesModalVisible}
                        getDirDetails={getDirDetails}
                        fileExplorerDataSource={updatedDirContents}
                        selectedFiles={selectedFiles}
                        parentDir={parentDir}
                        users={users && users.data && users.data.getUsers}
                        setToastMessage={setToastMessage}
                    />
                )}

            {isFileRenameModalVisible
                && (
                    <RenameFileContainer
                        visible={isFileRenameModalVisible}
                        setVisible={setIsFileRenameModalVisible}
                        getDirDetails={getDirDetails}
                        fileExplorerDataSource={updatedDirContents}
                        selectedFiles={selectedFiles}
                        parentDir={parentDir}
                        setToastMessage={setToastMessage}
                    />
                )}

            {isCreateFolderModalVisible
                && (
                    <CreateNewFolderContainer
                        visible={isCreateFolderModalVisible}
                        setVisible={setIsCreateFolderModalVisible}
                        currentDir={parentDir}
                        getDirDetails={getDirDetails}
                        fileExplorerDataSource={updatedDirContents}
                        setToastMessage={setToastMessage}
                    />
                )}

            <FileExplorer
                fileExporerBreadcrumb={fileExporerBreadcrumb}
                fileExplorerDataSource={updatedDirContents}
                fileSelectionChangeHandler={fileSelectionChangeHandler}
                fetchFolderData={fetchFolderData}
                dirDetailsLoading={dirDetailsLoading}
                selection={selection}
                setSelection={setSelection}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                isSharedDirectory={isSharedDirectory}
                showDownload={showDownload}
                downloadFiles={downloadFiles}
            />
        </Panel>
    );
};

export default FileExplorerContainer;
